import { Image } from "antd";
import LOGO from "../assets/logo.png";

type Props = {
  InHeader?: boolean;
  loaderLogo?: string;
  /** Square size for non-header; header uses this as logo height (px). */
  size?: number;
};

const Logo = ({ loaderLogo = LOGO, size, InHeader = false }: Props) => {
  const headerHeight = size ?? 52;
  const squareSize = size ?? 120;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        lineHeight: 0,
      }}
    >
      <Image
        src={loaderLogo ? loaderLogo : LOGO}
        alt="logo"
        preview={false}
        style={
          InHeader
            ? {
                objectFit: "contain",
                flexShrink: 0,
                height: headerHeight,
                width: "auto",
                maxWidth: Math.round(headerHeight * 4),
              }
            : {
                objectFit: "contain",
                flexShrink: 0,
                width: squareSize,
                height: squareSize,
              }
        }
      />
    </div>
  );
};

export default Logo;
